<template>
  <FormContainer :title="$t('title.question')" :onSubmit="onSubmit">
    <div class="columns">
      <div :class="`column ${isProcessGroup ? 'is-12' : 'is-9'}`">
        <FormItem>
          <b-input v-model="question.no" v-validate="'required|numeric'" name="no" />
        </FormItem>
        <FormItem>
          <b-input
            v-model="question.name"
            type="textarea"
            rows="2"
            v-validate="'required'"
            name="name"
            expanded
          />
        </FormItem>
        <FormItem>
          <b-input
            v-model="question.description"
            type="textarea"
            rows="2"
            name="description"
            expanded
          />
        </FormItem>
        <FormItem v-if="!isProcessGroup">
          <b-select
            expanded
            v-model="question.componentId"
            name="controlComponent"
            v-validate="'required'"
          >
            <option v-for="option in components" :value="option.id" :key="option.id">
              {{ option.name }}
            </option>
          </b-select>
        </FormItem>
      </div>
      <div class="column" v-if="!isProcessGroup">
        <FormItem>
          <b-input
            v-model="question.financialReportRaw"
            v-validate="'required'"
            name="financialReport"
            expanded
          />
        </FormItem>
        <FormItem>
          <b-input
            v-model="question.adaptationRaw"
            v-validate="'required'"
            name="adaptation"
            expanded
          />
        </FormItem>
        <FormItem>
          <b-input
            v-model="question.operationRaw"
            v-validate="'required'"
            name="operation"
            expanded
          />
        </FormItem>
        <FormItem>
          <b-input v-model="question.abuseRaw" v-validate="'required'" name="abuse" expanded />
        </FormItem>
      </div>
    </div>
  </FormContainer>
</template>

<script>
import ApiService from '../../../../_api/api.service'

export default {
  props: ['questionId', 'processId', 'isProcessGroup'],
  data () {
    return {
      question: {},
      components: []
    }
  },
  mounted () {
    this.getComponents()
    if (this.questionId) {
      this.getQuestion()
    }
  },
  methods: {
    getQuestion () {
      ApiService.get(`/process/${this.processId}/question/${this.questionId}`).then(data => {
        this.question = data
      })
    },
    getComponents () {
      ApiService.get('/select/components').then(data => {
        this.components = data
      })
    },
    onSubmit () {
      // if (parseInt(this.question.financialReportRaw) + parseInt(this.question.adaptationRaw) + parseInt(this.question.operationRaw) + parseInt(this.question.abuseRaw) !== 100) {
      //   this.$buefy.toast.open({
      //     message: 'Finansal Rapor, Uyum, Operasyon, Suistimal toplami 100 olmalıdır.',
      //     type: 'is-warning'
      //   })
      //   return
      // }
      ApiService.post(`/process/${this.processId}/question`, { question: this.question }).then(
        data => {
          this.question = data
          this.$emit('saved')
          this.$parent.close()
        }
      )
    }
  }
}
</script>
